// Logged-in customer wishlist API (DB-backed). Guests use wishlistStorage.js
// (localStorage); after login the guest list is synced via syncWishlist.
import apiClient from './apiClient.js';

export const getWishlist = () => apiClient.get('/account/wishlist');

export const addWishlistItem = (productId) =>
  apiClient.post('/account/wishlist', { productId });

export const removeWishlistItem = (productId) =>
  apiClient.delete(`/account/wishlist/${productId}`);

export const syncWishlist = (productIds = []) =>
  apiClient.post('/account/wishlist/sync', { productIds });
